import styled from 'styled-components';
import { Label } from 'reactstrap';
import { fontStyle } from '@whitelabel/helpers/style/type';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { getThemeProp } from '@whitelabel/helpers/style/get';
import { Alert } from '@whitelabel/component-library';

export const StyledContactPurpose = styled.div`
  max-height: 100vh;
`;

export const StyledLabel = styled(Label)`
  margin-bottom: 0.5rem;
  ${fontStyle('formLabel')};
`;

export const StyledDivider = styled.div.attrs(() => ({ className: 'divider' }))`
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-bottom: ${getThemeProp('borderStyle')};
  ${mediaBreakpointUp('md')`
    margin-top: 2rem;
    margin-bottom: 2rem;
  `}
`;

export const StyledButtonBlock = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  button {
    text-transform: uppercase;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 0;
`;
